<template>
    <div class="section" id="welcome">
        <div class="para">
            <p id="title">KHALIL KHALIL KHALIL </p> 

            <p>Accidently web devloper 
</p>         

        </div>
        <button id="btn"></button>
    </div>
</template>
<script>
    export default {
        name : 'Welcome'
    }
</script>